import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import { SidebarProvider } from '@/contexts/SidebarContext';
import AppSidebar from '@/components/AppSidebar';
import DashboardFooter from '@/components/DashboardFooter';
import { useSidebarContext } from '@/contexts/SidebarContext';
import { useIsMobile } from '@/hooks/use-mobile';
import { cn } from '@/lib/utils';
import { Layers } from 'lucide-react';
import StartupStashSection from '@/components/startup-stash/StartupStashSection';

const StartupStashLayout: React.FC = () => {
  const { compact } = useSidebarContext();
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const handleNavigate = (page: string) => {
    switch (page) {
      case 'dashboard':
      case 'deep-analysis':
      case 'recommended':
      case 'faq-serp':
        navigate('/dashboard');
        break;
      case 'eco':
        navigate('/eco');
        break;
      case 'fact-check':
        navigate('/fact-check');
        break;
      case 'reddit-hn':
        navigate('/reddit-hn');
        break;
      case 'startup-stash':
        break;
      default:
        console.log('Unknown navigation target:', page);
    }
  };

  return (
    <div className="flex min-h-screen w-full bg-gradient-to-br from-background via-background to-secondary/20">
      <AppSidebar activePage="startup-stash" onNavigate={handleNavigate} />
      <div className={cn("flex-1 min-w-0 transition-all duration-300", !isMobile && (compact ? "ml-16" : "ml-64"))}>
        <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 space-y-8">
          
          {/* Header Section */}
          <div className="text-center space-y-6 py-12">
            <div className="flex items-center justify-center gap-3 mb-6">
              <div className="p-4 rounded-full bg-primary/10 backdrop-blur-sm">
                <Layers className="h-10 w-10 text-primary" />
              </div>
            </div>
            <h1 className="text-5xl font-bold bg-gradient-to-r from-primary via-accent to-primary bg-clip-text text-transparent">
              Startup Stash Listicle Automation
            </h1>
            <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
              Generate and customize table of contents for your listicle posts with AI assistance. 
              Create engaging content that drives traffic and conversions.
            </p>
          </div>

          {/* Main Content */}
          <div className="w-full">
            <StartupStashSection />
          </div>
          
        </div>
        <DashboardFooter />
      </div>
    </div>
  );
};

const StartupStash: React.FC = () => {
  return (
    <SidebarProvider>
      <StartupStashLayout />
    </SidebarProvider>
  );
};

export default StartupStash;